import React, { useEffect, useState, useRef } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../../../CustomComponents/FieldInput";
import ReactSelect from "react-select";
import FieldArea from "../../../../CustomComponents/FieldText";
import FileAttachment from "../../UpdateModels/FileAttachment";
import { useSelector } from "react-redux";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import * as Yup from "yup";
import LoginLoaderButton from "../../../../Common/Loader/LoginLoaderButton";
import CustomReactQuill from "../../../../Common/CustomeLabel/ReactQuill/CustomReactQuill";
import { descriptionvalidation } from "../../../../Common/commonvalidation";
import AsteriskLabel from "../../../../Common/AsteriskLabel";
import useEnterKeySubmit from "../../../../../utils/useEnterKeySubmit";

const formdatatomap = [
  { title: "Image", name: "files", placeholder: "Select Image" },
  {
    title: (<>Expected deliverables <AsteriskLabel /></>),
    name: "deliverables",
    placeholder: "Mention deliverables here",
  },
  {
    title: (<>Preferred Language of Work Submission <AsteriskLabel /></>),
    name: "language_id",
    placeholder: "Select Language",
  },
];

const PExpectationPreferences = ({
  formData,
  setFormData,
  nextPage,
  previousPage,
}) => {
  const [loading, setLoading] = useState(false);
  const [work_sample, setWork_sample] = useState({
    files: formData?.files,
  });

  const path = "Assets/scss/FirstTimeUsers.module.scss";
  const formikRef = useRef(null);

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const [allLanguage, setAllLanguage] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState(
    formData?.languageindex,
  );

  const languagelist = useSelector(
    ({ categary: { languagelist } }) => languagelist,
  );

  useEffect(() => {
    setAllLanguage(languagelist);
  }, [languagelist]);

  const initialValues = {
    files: formData?.files,
    deliverables: formData?.deliverables,
    language_id: formData?.language_id,
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));

    setFormData((prevData) => ({
      ...prevData,
      ...values,
      files: work_sample?.files,
    }));
    nextPage();
    setLoading(false);
  };

  const handleNextClick = () => {
    if (formikRef.current) {
      formikRef.current.submitForm();
    }
  };

  const validationSchema = Yup.object().shape({
    language_id: Yup.string().required("Language is required"),
    deliverables: descriptionvalidation,
  });

  useEnterKeySubmit(handleNextClick);

  return (
    <div className="app-container ">
      <div className="col-lg-10  col-md-11 mx-auto expert-flow">
        <div className="col-lg-10 mx-auto">
          <div className="row about-row">
            <div className="col-lg-4    about-left">
              <h6>
                <span style={{minWidth:'max-content'}}>04/04</span><span>Upload Documents and Deliverables</span>
              </h6>
              <h2>Upload documents (If any) and mention deliverables</h2>
              <p>Enter amount for the project</p>
            </div>
            <div className="col-lg-6   about-right">
              <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                innerRef={formikRef}
                validationSchema={validationSchema}
                enableReinitialize
              >
                {(formik) => (
                  <Form>
                    {formdatatomap.map((prop, key) => {
                      if (prop.name == "files") {
                        return (
                          <FileAttachment
                            setWork_sample={setWork_sample}
                            selectedfiles={work_sample?.files}
                            formData={formData}
                            setFormData={setFormData}
                            key={key}
                          />
                        );
                      }
                      if (prop.name == "language_id") {
                        return (
                          <>
                            <div className="form-group mb-0" key={key}>
                              <label>{prop.title}</label>
                              <ReactSelect
                                options={
                                  Array.isArray(allLanguage) &&
                                  allLanguage.map((lang) => ({
                                    value: lang.id,
                                    label: lang.title,
                                  }))
                                }
                                placeholder="Select language"
                                value={selectedLanguage}
                                onChange={(selectedOption) => {
                                  formik.setFieldValue(
                                    "language_id",
                                    selectedOption.value,
                                  );
                                  formik.setFieldValue(
                                    "languageindex",
                                    selectedOption,
                                  );
                                  setSelectedLanguage(selectedOption);
                                }}
                              />
                            </div>
                            <ErrorMessage
                              name={prop.name}
                              component="div"
                              className="error"
                              style={{ color: "red" }}
                            />
                          </>
                        );
                      }
                      if (prop.name == "deliverables") {
                        return (
                          <div className=" form-group tell-about-margin">
                          
                            <CustomReactQuill
                              value={formik.values.deliverables}
                              formik={formik}
                              name={prop.name}
                              title={prop.title}
                            />
                            <ErrorMessage
                              name={prop.name}
                              component="div"
                              className="error"
                              style={{ color: "red" }}
                            />
                          </div>
                        );
                      }
                      return (
                        <FieldInput
                          title={prop.title}
                          name={prop.name}
                          placeholder={prop.placeholder}
                          key={key}
                        />
                      );
                    })}
                    <button
                      type="submit"
                      style={{ display: "none" }}
                      ref={formikRef}
                    ></button>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      <div className="button-container col-lg-8 col-md-11  mx-auto">
        <button
          disabled={loading}
          type="button"
          onClick={previousPage}
          className="prev-button"
        >
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/back-arrow.svg`}
            alt=""
          />
          Back
        </button>
        <button type="button" onClick={handleNextClick} className="next-button">
          {loading ? (
            <LoginLoaderButton />
          ) : (
            <>
              Next
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                alt=""
              />
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default PExpectationPreferences;
